//https://github.com/tldraw/tldraw/blob/c1b84bf2468caeb0c6e502f621b19dffe3aa8aba/packages/store/src/lib/setUtils.ts#L0-L1
// Moved CollectionDiff to here from "./Store"
// Moved RecordsDiff to here from "./Store"
/**
 * Combine multiple sets into a single set containing only the common elements of all sets.
 *
 * @param sets - The sets to combine.
 */ export function intersectSets(sets) {
    if (sets.length === 0) return new Set();
    const first = sets[0];
    const rest = sets.slice(1);
    const result = new Set();
    for (const val of first){
        if (rest.every((set)=>set.has(val))) {
            result.add(val);
        }
    }
    return result;
}
/**
 * Calculates a diff between two sets.
 *
 * @param prev - The previous set
 * @param next - The next set
 */ export function diffSets(prev, next) {
    const result = {};
    for (const val of next){
        if (!prev.has(val)) {
            result.added ??= new Set();
            result.added.add(val);
        }
    }
    for (const val of prev){
        if (!next.has(val)) {
            result.removed ??= new Set();
            result.removed.add(val);
        }
    }
    return result.added || result.removed ? result : undefined;
}
